import { gql } from '@apollo/client';

export const GET_CREATIVE_LIBRARY_ID_BY_ORGANIZATION_ID = gql`
  query GetCreativeLibraryIdByOrganizationID($organizationId: String!) {
    getCreativeLibraryIdByOrganizationIDV5(organizationId: $organizationId)
  }
`;
